import axios from "axios";
const deployEnvironment = require("../../deployEnvironment.js");

const API = deployEnvironment;
const STORAGE_KEY = "accessToken";

class SpacesDOSettingsApi {
  async getSpacesDoSettings() {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const getSpacesDoSettingsResponse = await axios.get(
      `${API}/api/spaces-do-settings`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const spacesDOSettings = getSpacesDoSettingsResponse.data;

    return new Promise((resolve, reject) => {
      try {
        if (!spacesDOSettings) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(spacesDOSettings);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
}

export const spacesDOSettingsApi = new SpacesDOSettingsApi();
